/* tslint:disable */
/* eslint-disable */
/**
 * BackOffice — Attributions par plateforme
 * Briques d\'un collaborateur par plateforme (override du compte, sémantique d\'override total avec repli sur le compte) et plafond délégable de la plateforme. Keyé par COLLABORATEUR (abpUserId) : un cabinet de N collaborateurs expose N lignes, et les collaborateurs d\'une corporate (sans ligne Courtier) sont adressables. Surface admin de l\'atelier des rôles + surface gouvernance du Portail Plateforme. 
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  GetBriquesCollaborateurPlateformeResponse,
  GetBriquesDelegablesResponse,
  GetCabinetsBriquesPlateformeResponse,
  GetCollaborateursBriquesPlateformeResponse,
  OperationResponse,
  SetBriquesCollaborateurPlateformeCommand,
  SetBriquesDelegablesCommand,
} from '../models/index';
import {
    GetBriquesCollaborateurPlateformeResponseFromJSON,
    GetBriquesCollaborateurPlateformeResponseToJSON,
    GetBriquesDelegablesResponseFromJSON,
    GetBriquesDelegablesResponseToJSON,
    GetCabinetsBriquesPlateformeResponseFromJSON,
    GetCabinetsBriquesPlateformeResponseToJSON,
    GetCollaborateursBriquesPlateformeResponseFromJSON,
    GetCollaborateursBriquesPlateformeResponseToJSON,
    OperationResponseFromJSON,
    OperationResponseToJSON,
    SetBriquesCollaborateurPlateformeCommandFromJSON,
    SetBriquesCollaborateurPlateformeCommandToJSON,
    SetBriquesDelegablesCommandFromJSON,
    SetBriquesDelegablesCommandToJSON,
} from '../models/index';

export interface GetBriquesCollaborateurRequest {
    plateformeId: string;
    abpUserId: string;
}

export interface GetBriquesCollaborateurGouvernanceRequest {
    abpUserId: string;
}

export interface GetBriquesDelegablesRequest {
    plateformeId: string;
}

export interface GetCabinetsBriquesRequest {
    plateformeId: string;
    searchString?: string;
    pageNumber?: number;
    pageSize?: number;
}

export interface GetCabinetsBriquesGouvernanceRequest {
    searchString?: string;
    pageNumber?: number;
    pageSize?: number;
}

export interface GetCollaborateursCabinetRequest {
    plateformeId: string;
    personneMoraleId: string;
}

export interface GetCollaborateursCabinetGouvernanceRequest {
    personneMoraleId: string;
}

export interface ResetBriquesCollaborateurRequest {
    plateformeId: string;
    abpUserId: string;
}

export interface ResetBriquesCollaborateurGouvernanceRequest {
    abpUserId: string;
}

export interface ResetBriquesDelegablesRequest {
    plateformeId: string;
}

export interface SetBriquesCollaborateurRequest {
    plateformeId: string;
    abpUserId: string;
    setBriquesCollaborateurPlateformeCommand: SetBriquesCollaborateurPlateformeCommand;
}

export interface SetBriquesCollaborateurGouvernanceRequest {
    abpUserId: string;
    setBriquesCollaborateurPlateformeCommand: SetBriquesCollaborateurPlateformeCommand;
}

export interface SetBriquesDelegablesRequest {
    plateformeId: string;
    setBriquesDelegablesCommand: SetBriquesDelegablesCommand;
}

/**
 * 
 */
export class AttributionsPlateformesApi extends runtime.BaseAPI {

    /**
     * Briques du membre dans la plateforme (compte, override, attribuables)
     */
    async getBriquesCollaborateurRaw(requestParameters: GetBriquesCollaborateurRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetBriquesCollaborateurPlateformeResponse>> {
        if (requestParameters['plateformeId'] == null) {
            throw new runtime.RequiredError(
                'plateformeId',
                'Required parameter "plateformeId" was null or undefined when calling getBriquesCollaborateur().'
            );
        }

        if (requestParameters['abpUserId'] == null) {
            throw new runtime.RequiredError(
                'abpUserId',
                'Required parameter "abpUserId" was null or undefined when calling getBriquesCollaborateur().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/plateformes/{plateformeId}/collaborateurs/{abpUserId}/briques`.replace(`{${"plateformeId"}}`, encodeURIComponent(String(requestParameters['plateformeId']))).replace(`{${"abpUserId"}}`, encodeURIComponent(String(requestParameters['abpUserId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetBriquesCollaborateurPlateformeResponseFromJSON(jsonValue));
    }

    /**
     * Briques du membre dans la plateforme (compte, override, attribuables)
     */
    async getBriquesCollaborateur(requestParameters: GetBriquesCollaborateurRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetBriquesCollaborateurPlateformeResponse> {
        const response = await this.getBriquesCollaborateurRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gouvernance : briques du membre dans MA plateforme active
     */
    async getBriquesCollaborateurGouvernanceRaw(requestParameters: GetBriquesCollaborateurGouvernanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetBriquesCollaborateurPlateformeResponse>> {
        if (requestParameters['abpUserId'] == null) {
            throw new runtime.RequiredError(
                'abpUserId',
                'Required parameter "abpUserId" was null or undefined when calling getBriquesCollaborateurGouvernance().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/vue-plateforme/collaborateurs/{abpUserId}/briques`.replace(`{${"abpUserId"}}`, encodeURIComponent(String(requestParameters['abpUserId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetBriquesCollaborateurPlateformeResponseFromJSON(jsonValue));
    }

    /**
     * Gouvernance : briques du membre dans MA plateforme active
     */
    async getBriquesCollaborateurGouvernance(requestParameters: GetBriquesCollaborateurGouvernanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetBriquesCollaborateurPlateformeResponse> {
        const response = await this.getBriquesCollaborateurGouvernanceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Plafond délégable de la plateforme
     */
    async getBriquesDelegablesRaw(requestParameters: GetBriquesDelegablesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetBriquesDelegablesResponse>> {
        if (requestParameters['plateformeId'] == null) {
            throw new runtime.RequiredError(
                'plateformeId',
                'Required parameter "plateformeId" was null or undefined when calling getBriquesDelegables().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/plateformes/{plateformeId}/briques-delegables`.replace(`{${"plateformeId"}}`, encodeURIComponent(String(requestParameters['plateformeId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetBriquesDelegablesResponseFromJSON(jsonValue));
    }

    /**
     * Plafond délégable de la plateforme
     */
    async getBriquesDelegables(requestParameters: GetBriquesDelegablesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetBriquesDelegablesResponse> {
        const response = await this.getBriquesDelegablesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Niveau 1 : les PM de la plateforme, paginées et cherchables
     */
    async getCabinetsBriquesRaw(requestParameters: GetCabinetsBriquesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetCabinetsBriquesPlateformeResponse>> {
        if (requestParameters['plateformeId'] == null) {
            throw new runtime.RequiredError(
                'plateformeId',
                'Required parameter "plateformeId" was null or undefined when calling getCabinetsBriques().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['searchString'] != null) {
            queryParameters['searchString'] = requestParameters['searchString'];
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['pageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/plateformes/{plateformeId}/cabinets-briques`.replace(`{${"plateformeId"}}`, encodeURIComponent(String(requestParameters['plateformeId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetCabinetsBriquesPlateformeResponseFromJSON(jsonValue));
    }

    /**
     * Niveau 1 : les PM de la plateforme, paginées et cherchables
     */
    async getCabinetsBriques(requestParameters: GetCabinetsBriquesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetCabinetsBriquesPlateformeResponse> {
        const response = await this.getCabinetsBriquesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gouvernance : les PM de MA plateforme, paginées et cherchables
     */
    async getCabinetsBriquesGouvernanceRaw(requestParameters: GetCabinetsBriquesGouvernanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetCabinetsBriquesPlateformeResponse>> {
        const queryParameters: any = {};

        if (requestParameters['searchString'] != null) {
            queryParameters['searchString'] = requestParameters['searchString'];
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['pageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/vue-plateforme/cabinets-briques`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetCabinetsBriquesPlateformeResponseFromJSON(jsonValue));
    }

    /**
     * Gouvernance : les PM de MA plateforme, paginées et cherchables
     */
    async getCabinetsBriquesGouvernance(requestParameters: GetCabinetsBriquesGouvernanceRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetCabinetsBriquesPlateformeResponse> {
        const response = await this.getCabinetsBriquesGouvernanceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Niveau 2 : les membres d\'une PM de la plateforme, avec leurs briques
     */
    async getCollaborateursCabinetRaw(requestParameters: GetCollaborateursCabinetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetCollaborateursBriquesPlateformeResponse>> {
        if (requestParameters['plateformeId'] == null) {
            throw new runtime.RequiredError(
                'plateformeId',
                'Required parameter "plateformeId" was null or undefined when calling getCollaborateursCabinet().'
            );
        }

        if (requestParameters['personneMoraleId'] == null) {
            throw new runtime.RequiredError(
                'personneMoraleId',
                'Required parameter "personneMoraleId" was null or undefined when calling getCollaborateursCabinet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/plateformes/{plateformeId}/cabinets/{personneMoraleId}/collaborateurs-briques`.replace(`{${"plateformeId"}}`, encodeURIComponent(String(requestParameters['plateformeId']))).replace(`{${"personneMoraleId"}}`, encodeURIComponent(String(requestParameters['personneMoraleId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetCollaborateursBriquesPlateformeResponseFromJSON(jsonValue));
    }

    /**
     * Niveau 2 : les membres d\'une PM de la plateforme, avec leurs briques
     */
    async getCollaborateursCabinet(requestParameters: GetCollaborateursCabinetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetCollaborateursBriquesPlateformeResponse> {
        const response = await this.getCollaborateursCabinetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gouvernance : les membres d\'une PM de MA plateforme, avec leurs briques
     */
    async getCollaborateursCabinetGouvernanceRaw(requestParameters: GetCollaborateursCabinetGouvernanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetCollaborateursBriquesPlateformeResponse>> {
        if (requestParameters['personneMoraleId'] == null) {
            throw new runtime.RequiredError(
                'personneMoraleId',
                'Required parameter "personneMoraleId" was null or undefined when calling getCollaborateursCabinetGouvernance().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/vue-plateforme/cabinets/{personneMoraleId}/collaborateurs-briques`.replace(`{${"personneMoraleId"}}`, encodeURIComponent(String(requestParameters['personneMoraleId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetCollaborateursBriquesPlateformeResponseFromJSON(jsonValue));
    }

    /**
     * Gouvernance : les membres d\'une PM de MA plateforme, avec leurs briques
     */
    async getCollaborateursCabinetGouvernance(requestParameters: GetCollaborateursCabinetGouvernanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetCollaborateursBriquesPlateformeResponse> {
        const response = await this.getCollaborateursCabinetGouvernanceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Supprime l\'override (retour aux briques du compte)
     */
    async resetBriquesCollaborateurRaw(requestParameters: ResetBriquesCollaborateurRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['plateformeId'] == null) {
            throw new runtime.RequiredError(
                'plateformeId',
                'Required parameter "plateformeId" was null or undefined when calling resetBriquesCollaborateur().'
            );
        }

        if (requestParameters['abpUserId'] == null) {
            throw new runtime.RequiredError(
                'abpUserId',
                'Required parameter "abpUserId" was null or undefined when calling resetBriquesCollaborateur().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/plateformes/{plateformeId}/collaborateurs/{abpUserId}/briques`.replace(`{${"plateformeId"}}`, encodeURIComponent(String(requestParameters['plateformeId']))).replace(`{${"abpUserId"}}`, encodeURIComponent(String(requestParameters['abpUserId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Supprime l\'override (retour aux briques du compte)
     */
    async resetBriquesCollaborateur(requestParameters: ResetBriquesCollaborateurRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.resetBriquesCollaborateurRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gouvernance : supprime l\'override (retour aux briques du compte, Owner uniquement)
     */
    async resetBriquesCollaborateurGouvernanceRaw(requestParameters: ResetBriquesCollaborateurGouvernanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['abpUserId'] == null) {
            throw new runtime.RequiredError(
                'abpUserId',
                'Required parameter "abpUserId" was null or undefined when calling resetBriquesCollaborateurGouvernance().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/vue-plateforme/collaborateurs/{abpUserId}/briques`.replace(`{${"abpUserId"}}`, encodeURIComponent(String(requestParameters['abpUserId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Gouvernance : supprime l\'override (retour aux briques du compte, Owner uniquement)
     */
    async resetBriquesCollaborateurGouvernance(requestParameters: ResetBriquesCollaborateurGouvernanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.resetBriquesCollaborateurGouvernanceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Supprime le plafond (retour au défaut — profil de la nature)
     */
    async resetBriquesDelegablesRaw(requestParameters: ResetBriquesDelegablesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['plateformeId'] == null) {
            throw new runtime.RequiredError(
                'plateformeId',
                'Required parameter "plateformeId" was null or undefined when calling resetBriquesDelegables().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/plateformes/{plateformeId}/briques-delegables`.replace(`{${"plateformeId"}}`, encodeURIComponent(String(requestParameters['plateformeId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Supprime le plafond (retour au défaut — profil de la nature)
     */
    async resetBriquesDelegables(requestParameters: ResetBriquesDelegablesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.resetBriquesDelegablesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Pose l\'override de briques du membre dans la plateforme
     */
    async setBriquesCollaborateurRaw(requestParameters: SetBriquesCollaborateurRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['plateformeId'] == null) {
            throw new runtime.RequiredError(
                'plateformeId',
                'Required parameter "plateformeId" was null or undefined when calling setBriquesCollaborateur().'
            );
        }

        if (requestParameters['abpUserId'] == null) {
            throw new runtime.RequiredError(
                'abpUserId',
                'Required parameter "abpUserId" was null or undefined when calling setBriquesCollaborateur().'
            );
        }

        if (requestParameters['setBriquesCollaborateurPlateformeCommand'] == null) {
            throw new runtime.RequiredError(
                'setBriquesCollaborateurPlateformeCommand',
                'Required parameter "setBriquesCollaborateurPlateformeCommand" was null or undefined when calling setBriquesCollaborateur().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/plateformes/{plateformeId}/collaborateurs/{abpUserId}/briques`.replace(`{${"plateformeId"}}`, encodeURIComponent(String(requestParameters['plateformeId']))).replace(`{${"abpUserId"}}`, encodeURIComponent(String(requestParameters['abpUserId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SetBriquesCollaborateurPlateformeCommandToJSON(requestParameters['setBriquesCollaborateurPlateformeCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Pose l\'override de briques du membre dans la plateforme
     */
    async setBriquesCollaborateur(requestParameters: SetBriquesCollaborateurRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.setBriquesCollaborateurRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gouvernance : pose l\'override (borné par le plafond délégable, Owner uniquement)
     */
    async setBriquesCollaborateurGouvernanceRaw(requestParameters: SetBriquesCollaborateurGouvernanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['abpUserId'] == null) {
            throw new runtime.RequiredError(
                'abpUserId',
                'Required parameter "abpUserId" was null or undefined when calling setBriquesCollaborateurGouvernance().'
            );
        }

        if (requestParameters['setBriquesCollaborateurPlateformeCommand'] == null) {
            throw new runtime.RequiredError(
                'setBriquesCollaborateurPlateformeCommand',
                'Required parameter "setBriquesCollaborateurPlateformeCommand" was null or undefined when calling setBriquesCollaborateurGouvernance().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/vue-plateforme/collaborateurs/{abpUserId}/briques`.replace(`{${"abpUserId"}}`, encodeURIComponent(String(requestParameters['abpUserId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SetBriquesCollaborateurPlateformeCommandToJSON(requestParameters['setBriquesCollaborateurPlateformeCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Gouvernance : pose l\'override (borné par le plafond délégable, Owner uniquement)
     */
    async setBriquesCollaborateurGouvernance(requestParameters: SetBriquesCollaborateurGouvernanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.setBriquesCollaborateurGouvernanceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Configure le plafond délégable
     */
    async setBriquesDelegablesRaw(requestParameters: SetBriquesDelegablesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['plateformeId'] == null) {
            throw new runtime.RequiredError(
                'plateformeId',
                'Required parameter "plateformeId" was null or undefined when calling setBriquesDelegables().'
            );
        }

        if (requestParameters['setBriquesDelegablesCommand'] == null) {
            throw new runtime.RequiredError(
                'setBriquesDelegablesCommand',
                'Required parameter "setBriquesDelegablesCommand" was null or undefined when calling setBriquesDelegables().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/plateformes/{plateformeId}/briques-delegables`.replace(`{${"plateformeId"}}`, encodeURIComponent(String(requestParameters['plateformeId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SetBriquesDelegablesCommandToJSON(requestParameters['setBriquesDelegablesCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Configure le plafond délégable
     */
    async setBriquesDelegables(requestParameters: SetBriquesDelegablesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.setBriquesDelegablesRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
